class KtmbApiService {

  safeGetItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`Error getting item ${key} from localStorage:`, error);
      return null;
    }
  }

  getAuthHeaders() {
    const userData = localStorage.getItem('userData');
    // const requestSignature = localStorage.getItem('requestSignature');
    
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (userData) {
      headers['userData'] = userData;
    }
    
    // if (requestSignature) {
    //   headers['requestSignature'] = requestSignature;
    // }
    
    return headers;
  }

  async getStations(filter) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ktmb/stations`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      let filtered;
      if (filter === 'AFC') {
        filtered = data.filter(station =>
          Array.isArray(station.trainServices) &&
          station.trainServices.some(service => service.toUpperCase() === 'AFC')
        );
      } else {
        filtered = data.filter(station =>
          Array.isArray(station.trainServices) &&
          station.trainServices.some(service => {
            const s = service.toUpperCase();
            return s === 'ETS' || s === 'INTERCITY' || s === 'SHUTTLE';
          })
        );
      }
      return filtered;
    } catch (error) {
      console.error('Error fetching stations:', error);
      throw error;
    }
  }

  async isOKU() {
    try {
  
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ktmb/isOku`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (response.ok) {
        const isOku = await response.json();
        return isOku; // This will be true or false
      } else {
        console.error('Error checking OKU status:', response.status);
        return false; // Default to false if there's an error
      }
    } catch (error) {
      console.error('Error checking OKU status:', error);
      return false; // Default to false if there's an error
    }
  }

  async getTimeTable(fromStationId, toStationId, departTime, pax) {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/ktmb/trips?fromStationId=${fromStationId}&toStationId=${toStationId}&departTime=${departTime}&pax=${pax}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });
      if (!response.ok) {
        // Try to parse error message if available
        let errorMsg = `HTTP error! status: ${response.status}`;
        try {
          const data = await response.json();
          if (data && data.error) errorMsg = data.error;
          console.log("errorMsg", errorMsg);
        } catch {}
        throw errorMsg;
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching timetable:', error);
      throw (typeof error === 'string' ? error : (error.message || 'Unknown error'));
    }
  }

  async getKomuterTimeTable(fromStationId, toStationId, departTime) {
    try {
      const params = new URLSearchParams({
        fromStationId,
        toStationId,
      });
      if (departTime) params.append('departTime', departTime);
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/ktmb/timetable-by-id?${params.toString()}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });
      if (!response.ok) {
        let errorMsg = `HTTP error! status: ${response.status}`;
        try {
          const data = await response.json();
          if (data && data.error) errorMsg = data.error;
        } catch {}
        throw new Error(errorMsg);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching Komuter timetable:', error);
      throw error;
    }
  }
}

export default KtmbApiService;
